export default "__VITE_ASSET__x8gdqEZX__"